import { lang } from '@umu/ukit-lang';
import React, { useEffect, ReactNode, useRef, useState, useCallback } from 'react';
import { $window } from '@umu/umu-dom';
import If from '../if';
import { MutationChild } from './mutationChild';
import './simpleToggleLine.scss';

export interface ISimpleToggleLineProps {
    className: string;
    maxLine: number;
    children?: ReactNode;
}

let factHeight = 0;
let isDomLoaded = false;

export function SimpleToggleLine(props: ISimpleToggleLineProps) {
    const contentRef = useRef<HTMLDivElement>(null);
    const [isShowBtn, setShowBtn] = useState(false);
    const [isToggle, setIsToggle] = useState(false);
    useEffect(() => {
        if (contentRef.current && isDomLoaded) {
            const overflowHeight = getHeights();
            const height = isToggle || factHeight <= overflowHeight ? 'auto' : `${overflowHeight}px`;
            contentRef.current.style.height = height;
        }
    }, [isToggle]);

    const onChildDomChanged = useCallback(() => {
        if (contentRef.current) {
            const overflowHeight = getHeights();
            if (factHeight > overflowHeight) {
                contentRef.current.style.height = `${overflowHeight}px`;
                setShowBtn(true);
            }
        }
    }, [isToggle]);

    const onToggle = useCallback(() => {
        const isToggled = !isToggle;
        setIsToggle(isToggled);
    }, [isToggle]);

    const getHeights = () => {
        if (contentRef.current) {
            const css = $window.getComputedStyle(contentRef.current);
            const lineHeight = parseFloat(css.lineHeight || '0');
            factHeight = Math.max(parseFloat(css.height || '0'), factHeight);
            const overflowHeight = lineHeight * props.maxLine;
            isDomLoaded = true;
            return overflowHeight;
        }
        return 0;
    };

    return (
        <div className="desc-rich">
            <div className={`simple-toggle-line ${props.className || ''}`}>
                <MutationChild onChildDomChanged={onChildDomChanged} ref={contentRef}>
                    {props.children}
                </MutationChild>

                <If condition={isShowBtn && !isToggle}>
                    <div className="overlayer" />
                </If>
            </div>
            <If condition={isShowBtn}>
                <span className="toggle-btn" onClick={onToggle}>
                    {isToggle ? lang('收起') : lang('展开')}
                </span>
            </If>
        </div>
    );
}
